module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0014-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev179"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "lev180"
    }
  }, [_vm._v("THE IMPROVED CART HORSE.")])]), _c('a', {
    attrs: {
      "id": "lev180"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("IT will be gratifying to most of our readers to know that the spirit of improvement has extended itself greatly to this useful breed; and to the advantages of strength and docility, has added those of form, activity, and vigour. George, Baker, Esq. of Elemore, in the county of Durham, has a remarkably fine Horse of this kind, from which this figure was drawn.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v(".   .   .")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "lev180"
    }
  }, [_vm._v("Till of late years, "), _c('em', [_vm._v("Pack Horses")]), _vm._v(" were employed, in the northern counties of England, to carry the different manufactures and articles of traffic from one part of the kingdom to another; but the improved state of our roads has caused that mode of conveyance to be almost entirely laid aside. In their journies over trackless moors, they strictly adhered to the line of order and regularity custom ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("had taught them to observe: the leading Horse, which was always chosen for his sagacity and steadiness, being furnished with bells, gave notice to the rest, which followed the sound, and generally without much deviation, though sometimes at a considerable distance. The following anecdote will shew with what obstinate perseverance they have been known to observe the line of their order:—Some years ago, one of these Horses, which had been long accustomed to follow his leader, by accident or fatigue, was thrown into an inferior rank: the poor animal, as if sensible of his disgrace, by the most strenuous exertions, at length recovered his usual station, which he maintained during the remainder of the journey; but on his arrival at the inn-yard, he dropped down dead upon the spot, his life falling a sacrifice to his ambition,—a species of heroism we must admire even in the brute creation.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0015-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd818f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_15_ch7.vue
// module id = 96
// module chunks = 0